import { JoinMemberMode } from "./joinAsMemberMode";

export enum DealType {
    annual_fee = "annual_fee",
    prepaid = "prepaid",
}

export type RechargeDeal = {
    id: string;
    annual_amount: string | null;//: "10.0"
    bonus_amount: string | null;//: null / "10.0"
    cash_amount: string | null;//: null / "100.0"
    deal_type: DealType;//:  "annual_fee" / "prepaid"
    foreign_name: string//: "年费$10" /  "充值$100, 送$10"
    name: string,//: "Annual fee $10" / "Pay $100, Get $10"
}


export type LoyaltyContractSetting = {
    cash_back_ratio: string;//"0.05"
    created_at?: string;
    deal_contract_id?: number;//: 2058
    discount_ratio: string;//: "0.9"
    join_member_mode: JoinMemberMode;//: "annual_fee_join","recharge_join","free_join"
    new_member_for_days: number | null,//: null
    recharge_available_restrict_days: number;//: 1
    regular_member_for_days: number | null;//: null
    annual_fee_amount?: string;
    annual_fee_deal_id?: string;
    wallet_logo_url?: string;
    wallet_icon_url?: string;
    wallet_strip_url?: string;
    logo_url: string;
    photo_url: string;
    enable_register: boolean;//是否允许通过loyalty_web来注册新用户
}

export type RestaurantInfo = {
    name: string;
    foreign_name: string;
    id: number;
    address: {
        address1: string;
        address2: string | null;
        city: string;
        country: string;
        delivery_zone_id: string | null;
        latitude: number;
        longitude: number;
        state: string;
        zip_code: string;
    } | null;
    language: string;
    logo_url: string | null;
    phone_number: string;
    restaurant_group_id: string;
    service_region_id: string;
};
export type RestaurantGroupContract = {
    id: string;
    commission_rate: string;
    currency: string;
    description: string;
    gift_card_is_active: boolean;
    is_active: boolean;
    name: string;
    vendor_id: string;
    vendor_type: string;//RestaurantGroup
};
export type RestaurangGroup = {
    id: string;
    groupContract: RestaurantGroupContract | null;
    includRestaurantList: RestaurantInfo[];
}

export type RestaurantLoyaltySetting = {
    restaurangGroup: RestaurangGroup | null;
    loyaltyContractSetting: LoyaltyContractSetting | null;
    prepaidDealList: RechargeDeal[];
    annualDeal: RechargeDeal | null;
}

export enum ONLINE_PAYMENT_CHANNEL {
    Stripe = "stripe",
    Adyen = "adyen",
}